import { Component, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

@Component({
   selector: 'app-spinner-pno',
   template: `<div
      class="spinner-PNO"
      [ngStyle]="{ 'background-image': spinnerBg }"
   ></div>
    <div class="spinner-PNO">
           <div class="spinner-PNO-image iconSVG"  [inlineSVG]="'/assets/images/DEFAULT_spinner.svg'" ></div>
       </div>
   
   `,
})
export class SpinnerPNOComponent implements OnInit {
   public spinnerBg: string = ''

   constructor(public dialogRef: MatDialogRef<SpinnerPNOComponent>) {}

   ngOnInit() {
      console.log('SpinnerComponent - init')

      this.startSpinner()
   }

   startSpinner() {
      console.log('SpinnerComponent - startSvgSpinner')

      this.spinnerBg = 'none'
   }

   stopSpinner() {
      console.log('SpinnerComponent - stopSvgSpinner')

      this.spinnerBg = 'none'
   }
}


@Component({
   selector: 'app-spinner-b4r',
   template: `<div class="spinner-B4R-container">
       <div class="spinner-B4R">
           <div class="spinner-B4R-image iconSVG"  [inlineSVG]="'/assets/images/B4R-spinner.svg'" ></div>
       </div>
   </div>`
})
export class SpinnerB4RComponent implements OnInit {

   public spinnerBg: string = '';

   constructor(public dialogRef: MatDialogRef<SpinnerB4RComponent>) { }

   ngOnInit() {

       console.log('SpinnerComponent - init');

       this.startSpinner();
   }

   startSpinner()  {

       console.log('SpinnerComponent - startSvgSpinner');

       this.spinnerBg = 'none';
   }

   stopSpinner(){

       console.log('SpinnerComponent - stopSvgSpinner');

       this.spinnerBg = 'none';
   }
}



@Component({
 selector: 'app-spinner-shyps',
 template: `<div class="spinner-SHYPS-container">
       <div class="spinner-SHYPS">
           <div class="spinner-SHYPS-image iconSVG"  [inlineSVG]="'/assets/images/SHYPS-spinner.svg'" ></div>
       </div>
   </div>`
})
export class SpinnerSHYPSComponent implements OnInit {

 public spinnerBg: string = '';

 constructor(public dialogRef: MatDialogRef<SpinnerSHYPSComponent>) { }

 ngOnInit() {

   console.log('SpinnerComponent - init');

   this.startSpinner();
 }

 startSpinner()  {

   console.log('SpinnerComponent - startSvgSpinner');

   this.spinnerBg = 'none';
 }

 stopSpinner(){

   console.log('SpinnerComponent - stopSvgSpinner');

   this.spinnerBg = 'none';
 }
}


@Component({
 selector: 'app-spinner-bins',
 template: `<div class="spinner-BINS-container">
       <div class="spinner-BINS">
           <div class="spinner-BINS-image iconSVG"  [inlineSVG]="'/assets/images/BINS-spinner.svg'" ></div>
       </div>
   </div>`
})
export class SpinnerBINSComponent implements OnInit {

 public spinnerBg: string = '';

 constructor(public dialogRef: MatDialogRef<SpinnerBINSComponent>) { }

 ngOnInit() {

   console.log('SpinnerComponent - init');

   this.startSpinner();
 }

 startSpinner()  {

   console.log('SpinnerComponent - startSvgSpinner');

   this.spinnerBg = 'none';
 }

 stopSpinner(){

   console.log('SpinnerComponent - stopSvgSpinner');

   this.spinnerBg = 'none';
 }
}



